import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { ConnectivityService } from '@app/server/shared/connectivity.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class ConnectivityInterceptor implements HttpInterceptor {
  constructor(private connectivityService: ConnectivityService) {}

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.connectivityService.isApiRequest(request.url)) {
      return next.handle(request);
    }

    return next.handle(request).pipe(
      tap({
        next: (event) => {
          if (event instanceof HttpResponse) {
            this.connectivityService.reportApiReachable();
          }
        },
        error: (error) => {
          if (!(error instanceof HttpErrorResponse)) {
            return;
          }

          if (error.status === 0) {
            // Status zero means the browser did not receive an HTTP response.
            this.connectivityService.reportApiUnavailable();
          } else {
            // Any real HTTP status confirms that the API was reachable.
            this.connectivityService.reportApiReachable();
          }
        }
      })
    );
  }
}
